/**
 * Constructor for loginController
 *
 * @class loginController
 * @param { Object } $scope - The scope of the controller.
 * @param { Object } $http - The Angular $http service.
 * @param { Object } $location - The Angular $location service.
 * @param { Object } externalLogin - The external login service.
 * @param { Object } __env - The environment configuration.
 */

angular.module("app").controller("loginController", [
  "$scope",
  "$http",
  "$location",
  "$window",
  "externalLogin",
  "__env",
  "$log",
  function($scope, $http, $location, $window, externalLogin, __env, $log) {
    $scope.isSso = __env.isSsoEnabled;
    $scope.isGoogleEnabled = __env.isGoogleEnabled;
    $scope.isLoggingIn = false;

    /* delete cookie by name */
    $scope.deleteCookie = function(name) {
      document.cookie =
        name +
        "=;domain=" +
        __env.domain +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    };

    // when navigating to this page, delete the old cookies for logout
    $scope.deleteCookie(__env.sessionCookieName);
    $scope.deleteCookie(__env.authCookieName);
    $scope.deleteCookie(__env.uniqueSessionCookieName);
    $scope.deleteCookie(__env.emailCookieName);

    /**
     * Handles password reset event from the front page and prepares the http request for
     * resetting password
     *
     * @function
     */
    $scope.changePassword = function() {
      if ($scope.passwordForm.$pristine) {
        $scope.passwordForm.newPassword.$setDirty();
        $scope.passwordForm.matchPassword.$setDirty();
        $scope.passwordForm.oldPassword.$setDirty();

        return;
      }

      if ($scope.newPassword !== $scope.matchPassword) {
        $scope.setErrorMessage("Passwords must match to be updated.");
        return;
      }

      // make sure there are no errors
      if ($scope.passwordForm.$valid) {
        var url = __env.apiBaseUrl + "login/password";
        var errorMessage =
          "Invalid Request. Please contact your Account Manager.";
        var data = {
          email: $scope.$parent.userEmail,
          password: $scope.oldPassword,
          newPassword: $scope.newPassword
        };
        var method = "put";

        $scope.httpRequest(url, method, errorMessage, data);
      }
    };

    /**
     * Handles login event from the front page and prepares the http request for login
     *
     * @function
     */
    $scope.login = function() {
      // if the user hasn't entered anything, show the errors
      if ($scope.loginForm.$pristine) {
        $scope.loginForm.username.$setDirty();
        $scope.loginForm.password.$setDirty();

        return;
      }

      // make sure there are no errors
      if ($scope.loginForm.$valid) {
        // set the username and password to pass
        var data = {
          Email: $scope.typedUsername,
          Password: $scope.typedPassword
        };
        var url = __env.apiBaseUrl + "login/password";
        var errorMessage = "The credentials supplied are invalid.";
        var method = "post";
        $scope.$parent.userEmail = $scope.typedUsername;
        $scope.httpRequest(url, method, errorMessage, data);
        $scope.isLoggingIn = true;
      }
    };

    /**
     * Sends Http request to server
     * on success, navigates to desired page or to home page
     *
     * @method httpRequest
     * @param { string } url - url to call
     * @param { string } method - The HTTP method to use
     * @param { string } errorMessage - message to display on error
     * @param { Object } data - data to post
     */
    $scope.httpRequest = function(url, method, errorMessage, data) {
      $http({
        url: url,
        data: data,
        method: method,
        headers: {
          "Content-Type": "application/json"
        }
      }).then($scope.onSuccess, $scope.onError);
    };

    /**
     * Creates the cookie used for authentication
     *
     * @function createCookie
     * @param { string } key - The unique key of the session
     * @param { string } secure - If true the cookie is set with the secure flag
     */
    $scope.createCookie = function(name, key, secure) {
      // Domain -- This should likely be .dev.assentcompliance.com for dev instances instead of a catch-all

      if (name && key) {
        // cookie expiration disabled temporarily until session extension extends cookie
        // ACP-7111
        document.cookie = name + "=" + key + ";domain=" + __env.domain + ";" + (secure ? "secure;" : "");
      }
    };

    /**
     * Callback to process a successful call to the login API
     *
     * @function onSuccess
     * @param { Object } response - The response object coming from the $http promise
     * @param { Object } response.data - The data coming out of the login API
     * @param { string } response.data.sessionKey - Key of the session
     * @param { Object[] } response.data.portals - List of portals the use has access to
     * @param { string } portals[].portalHomeUri - Uri of the portal's home page
     */
    $scope.onSuccess = function(response) {
      if (
        typeof response.config.data.state !== "undefined" &&
        response.config.data.state !== "undefined" &&
        response.config.data.state !== 'null'
      ) {
        var state = atob(response.config.data.state);

        //replacing startswith with indexof === 0 due to ie11 compatability
        if (state.indexOf("http") === 0) {
          $scope.returnUrl = decodeURIComponent(state);
        } else if (state.indexOf("returnUrl") === 0) {
          $scope.returnUrl = decodeURIComponent(state).slice(
            state.indexOf("=") + 1
          );
        } else {
          $scope.targetPage = state;
        }
      }

      $scope.isLoggingIn = false;
      $scope.setResponse(response);

      // create session cookie
      $scope.createCookie(
        __env.sessionCookieName,
        response.data.sessionKey,
        __env.secureCookies
      );

      // create email cookie
      $scope.createCookie(
        __env.emailCookieName,
        response.data.email,
        __env.secureCookies
      );

      // create JWT cookie
      $scope.createCookie(
        __env.authCookieName,
        response.data.token,
        __env.secureCookies
      );

      // create unique session cookie
      $scope.createCookie(  
        __env.uniqueSessionCookieName,
        response.data.uniqueSessionGuid,
        __env.secureCookies
      );

      // clear the supplier filters as they login
      localStorage.setItem("supplierFilters", "{}");

      var portals = response.data.portals;

      if (!portals || portals.length <= 0) {
        $scope.setErrorMessage(
          "You don't seem to have permissions for anything. Please contact your site administrator"
        );

        return;
      }

      var redirectUrl;
      var returnUrlProvided = typeof $scope.returnUrl !== "undefined";
      if (returnUrlProvided) {
        redirectUrl = $scope.returnUrl;
      } else {
        var baseUrl =
          portals.length > 1 ? __env.adminConsoleUrl : portals[0].portalHomeUri;

        var delimeter = baseUrl === __env.adminConsoleUrl ? "/#/?pg=" : "/";

        var AcmPortalTypeId = 2;
        var targetPage =
          portals.length !== 1 || portals[0].portalTypeId === AcmPortalTypeId
            ? $scope.targetPage
            : "";

        redirectUrl = baseUrl + delimeter + targetPage;
      }

      document.location.href = redirectUrl;
    };

    /**
     * Callback to process an unsuccesful attempt at login in
     *
     * @function onError
     * @param { Object } response - Response object coming out of the Angular $http promise
     * @param { Object } response.data - The data coming out of the login API
     *
     */
    $scope.onError = function(response) {
      $scope.setResponse(response);
      $scope.isLoggingIn = false;
      if (
        response.data &&
        response.data.message === "User must change password"
      ) {
        errorMessage = "You must change your password";
        $location.path("/login/password");
      } else if (
        response.data &&
        response.data.exceptionType ===
          "CoreAuthentication.Exceptions.UserLockedOutException"
      ) {
        errorMessage =
          "Your account is currently locked. Please contact your Account Administrator for assistance.";
        $location.path("/login");
      } else if (
        response.data &&
        response.data.exceptionType ===
          "CoreAuthentication.Exceptions.ValidationErrorException"
      ) {
        var isInvalidEmail = false;
        errorMessage = "<ul>";
        var messages = response.data.validationErrors;

        for (var i = 0; i < messages.length; i++) {
          if (messages[i].code !== "InvalidEmail") {
            errorMessage += "<li>" + messages[i].description + "</li>";

            $scope.oldPassword = "";
            $scope.newPassword = "";
            $scope.matchPassword = "";
          } else {
            isInvalidEmail = true;
          }
        }

        if (isInvalidEmail) {
          errorMessage =
            "Unauthorized Login. Please try again or contact your Account Administrator for assistance.";
          $location.path("/login");
        } else {
          errorMessage += "</ul>";
          $location.path("/login/password");
        }
      } else if (
        response.data &&
        response.data.exceptionType ===
          "CoreAuthentication.Exceptions.UserDeactivatedException"
      ) {
        errorMessage =
          "Your login has expired. Email customersupport@assentcompliance.com to create a support ticket and re-enable your account for this Information System.";
        $location.path("/login");
      } else {
        errorMessage =
          "Unauthorized Login. Please try again or contact your Account Administrator for assistance.";
        $location.path("/login");
      }

      $scope.setErrorMessage(errorMessage);
    };

    /**
     * Initiates the external login procedures by calling the login API to get a nonce value.
     * If successful, redirects to the SSO server
     * Otherwise sets an error message.
     *
     * @function  initiateExternalLogin
     */
    $scope.initiateExternalLogin = function() {
      // need to strip the page state from the url
      var stateBeginSymbol = $location.url().indexOf("http", 1) > 0 ? "?" : "=";
      var stateBeginIndex = $location.url().indexOf(stateBeginSymbol) + 1;
      var state =
        stateBeginIndex > 0
          ? btoa($location.url().slice(stateBeginIndex))
          : "null";

      externalLogin.GetNonce(state).then(
        function(response) {
          $scope.setResponse(response);
          var nonce = response.data.nonce;
          var currentState = response.data.state;

          var uri = externalLogin.getExternalLoginUri(
            currentState,
            nonce,
            $scope.isGoogleEnabled
          );

          $window.location.href = uri;
        },
        function(response) {
          if (
            response.data &&
            response.data.exceptionType ===
              "CoreAuthentication.Exceptions.UserDeactivatedException"
          ) {
            errorMessage =
              "Your login has expired. Email customersupport@assentcompliance.com to create a support ticket and re-enable your account for this Information System.";
            $location.path("/login");
          } else {
            errorMessage =
              "Unauthorized Login. Please try again or contact your Account Administrator for assistance.";
            $location.path("/login");
          }
          $scope.setResponse(response);
          $scope.setErrorMessage(errorMessage);
        }
      );
    };

    /**
     * Sets the response property of the $scope object,
     *
     * @function setResponse
     * @param { Object } response - Response object coming out of the Angular $http promise
     */
    $scope.setResponse = function(response) {
      $scope.response = response;
    };

    // processing error types on the query string
    if (typeof $scope.errorType !== "undefined") {
      var errorType = $scope.errorType;
      $location.search("et", null);
      if (errorType === "timeout") {
        var timeoutErrorMessage =
          "You have been logged out of your account due to inactivity. Please log in again.";
        $scope.setErrorMessage(timeoutErrorMessage);
      }
    }

    // processing external login information on the query string
    var search = $location.search();
    var state = search.state;
    var token = search.id_token;

    if (state && token) {
      externalLogin
        .externalLogin(state, token)
        .then($scope.onSuccess, function(response) {
          if (
            response.data &&
            response.data.exceptionType ===
              "CoreAuthentication.Exceptions.UserDeactivatedException"
          ) {
            errorMessage =
              "Your login has expired. Email customersupport@assentcompliance.com to create a support ticket and re-enable your account for this Information System.";
            $location.path("/login");
          } else {
            errorMessage =
              "Unauthorized Login. Please try again or contact your Account Administrator for assistance.";
            $location.path("/login");
          }
          $scope.setResponse(response);
          $scope.setErrorMessage(errorMessage);
          $location.search({});
        });
    }
  }
]);
